import supabaseClient from '@/api/supabaseClient';
import { FunctionsHttpError, SupabaseClient } from '@supabase/supabase-js';
import { useMutation } from '@tanstack/react-query';
import { ReinviteChildUserRequest } from '@/types/request/ReinviteChildUserRequest';

const useReinviteChildUser = () => {
  const client = supabaseClient;

  const mutationFn = async (request: ReinviteChildUserRequest) => {
    return reinviteChildUser(client, request);
  };

  return useMutation({
    mutationFn,
  });
};

export default useReinviteChildUser;

async function reinviteChildUser(client: SupabaseClient, request: ReinviteChildUserRequest): Promise<void> {
  const { error } = await client.functions.invoke('reinvite_child_user', {
    body: { ...request },
  });

  if (error && error instanceof FunctionsHttpError) {
    const errorMessage = await error.context.json();

    if (errorMessage.error) {
      throw new Error(errorMessage.error);
    }

    throw new Error(error.message);
  }

  return;
}
